/**
 * State used in rendering ColorSwatch
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
